import React, { useState, useEffect, useRef, useContext } from "react";
import {
  FirstCol,
  Header,
  MainInfoWrapper,
} from "src/components/udb/commonStyle";
import styled, { withTheme } from "styled-components";
import { getDepositStatus } from "src/config/api";
import { useParams, useNavigate } from "react-router-dom";
import DepositMessage from "src/components/udb/Message";
import UDBHeader from "src/components/UDBHeader";
import config from "src/config/config";
import { withAppContext } from "src/store/initAppContext";
import { Player } from "@lottiefiles/react-lottie-player";
import { UserContext } from "../index";
import { TriggerPxl, TriggerPxlParticular, pixelHandler, taboolaPxl, trackOutBrainEvent } from "src/pages/auth/Signup/Signup";
import { depositSigmentPxl } from "./Deposit";
import {SRTM} from 'src/util/sportradarEvent';
import PixelsTrigger from "src/components/common/PixelsTrigger";
import { addressablePxlDeposit, addressablePxlPageView, addressablePxlReDeposit } from "src/util/addressablePxl";
import { fbPxlPurchase } from "src/util/fbpixel";

type transStateProps = {
  status: string;
  message: string;
  amount: string;
  methodtype?: string;
  showMsg: boolean;
  source?:string;
  createdAt: any,
  transactionId: any;
};

const defaultTransState: transStateProps = {
  status: "",
  amount: "",
  message: "",
  showMsg: false,
  source:"",
  createdAt: "",
  transactionId: ""
};

const TriggerPxlPurchase = (
  marketingSource = "",
  isprev = false,
  isLead = false,
  isPurchase = false,
  brandID = 31,
  isFtd = true
) => {
  if (marketingSource && isFtd) {
    pixelHandler(marketingSource,isprev,isLead,isPurchase,brandID,isFtd);
  }
};

function DepositStatus(props) {
  const [transationState, setTransationState] = useState(defaultTransState);
  const [animationImage, setAnimationImage] = useState("");
  const [popup, setPopup] = useState(true);
  const [smartsolutionwebpixel, setSmartsolutionwebpixel] = useState(false);
  //for blockchain pixel
  const [trackerads,setTrackerads] = useState({
    ftd:false,
    rd:false
  })
  const urlParams = useParams();
  const navigate = useNavigate();
  const timer = useRef(undefined);
  const depositeUrl = "/member/finance/deposit";

  const [outbrain410, setOutbrain410] = useState(false);
  const [taboola1063, setTaboola1063] = useState(false);
  const [mgidpxl1064, setMgidpxl1064] = useState(false);

  const [napptix, setNapptix] = useState({
    '31':false,
    '47':false
  });

  const [finovationPxl73,setFinovationPxl73 ] = useState(false)
  const [finovationPxl74,setFinovationPxl74 ] = useState(false)

  // const {
  //   app: { brandId },
  //   theme
  // } = props;
  const { theme,theme:{config:{showOnlyOnFun}}, app: { brandId}} = props;
  const { userInfo } = useContext(UserContext);

  useEffect(() => {
    //for sport radar
    try {
      SRTM.init(brandId)
    } catch (error) {
      console.log(' ')
    }
    
    let isEmpty = Object.values(urlParams);
    if (isEmpty.length) {
      getDepositStatus(urlParams)
        .then((res) => {
          const { data = {} } = res.data;
          const {
            is_first_time_deposit,
            is_redeposit,
            is_manual_deposit,
            is_400_percent_deposit,
            user_source,
            is_crypto
          } = res.data;

          const payment_gateway_id = data.payment_gateway_id;
          const { created, transaction_sn } = data
       

          // const { blueTierAnimation,silverTierAnimation,goldTierAnimation,platinumTierAnimation,eliteTierAnimation } = res.data;
          const { status } = data;
          //do not writing anything for mow
          //just hiding popup images in case of failure
          if (!status || status === "FAILURE") {
            setPopup(false);
          }
          // adding animation popups

          //  if (is_first_time_deposit === true) {
          //      setAnimationImage(theme.image.firstDepositAnimation)
          //  } else if(is_redeposit){
          //      setAnimationImage(theme.image.refillDepositAnimation)
          //  } else {
          //     setPopup(false)
          //  }
          
          //       if (is_400_percent_deposit) {
          //         setAnimationImage(theme.image.firstDepositAnimation400)
          //       }
          //       else if (is_first_time_deposit === true && is_400_percent_deposit === false) {
          //         setAnimationImage(theme.image.firstTimeDeposit300Animation);
          //       } else if (userInfo.tier === "BLUE_TIER" && is_redeposit) {
          //         setAnimationImage(theme.image.blueTierAnimation);
          //       } else if (userInfo.tier === "SILVER_TIER" && is_redeposit) {
          //         setAnimationImage(theme.image.silverTierAnimation);
          //       } else if (userInfo.tier === "GOLD_TIER" && is_redeposit) {
          //         setAnimationImage(theme.image.goldTierAnimation);
          //       } else if (userInfo.tier === "PLATINUM_TIER" && is_redeposit) {
          //         setAnimationImage(theme.image.platinumTierAnimation);
          //       } else if (userInfo.tier === "ELITE_TIER" && is_redeposit) {
          //         setAnimationImage(theme.image.eliteTierAnimation);
          //       } else {
          //         setPopup(false);
          //       }

          // optimised the popup code
          if (payment_gateway_id === "f6fea746b42947468e644495aee17d7a" && is_redeposit) {
            switch (userInfo.tier) {
                case "BLUE_TIER":
                    setAnimationImage(theme.image.OnePercentAnimation); //blueTierAnimation
                    break;
                case "SILVER_TIER":
                    setAnimationImage(theme.image.blueTierAnimation); //silverTierAnimation
                    break;
                case "GOLD_TIER":
                    setAnimationImage(theme.image.silverTierAnimation);  //goldTierAnimation
                    break;
                case "PLATINUM_TIER":
                    setAnimationImage(theme.image.goldTierAnimation); //platinumTierAnimation
                    break;
                case "ELITE_TIER":
                    setAnimationImage(theme.image.platinumTierAnimation); //eliteTierAnimation
                    break;
                default:
                    setPopup(false);
                    break;
              }
            }
            else {
                if (is_400_percent_deposit&&!showOnlyOnFun) {
                    setAnimationImage(theme.image.firstDepositAnimation400);
                } 
                else if (is_first_time_deposit && is_400_percent_deposit && showOnlyOnFun) {
                  setAnimationImage(theme.image.firstTimeDeposit488Animation);
                } else if (is_first_time_deposit && !is_400_percent_deposit && showOnlyOnFun) {
                  setAnimationImage(theme.image.firstTimeDeposit388Animation);
                } else if (is_first_time_deposit && !is_400_percent_deposit) {
                  setAnimationImage(theme.image.firstTimeDeposit300Animation);
                } 
                else if (is_crypto && brandId === 61) { // crypto reload Animation for crypto whiteLabel(61)
                  switch (userInfo.tier) {
                    case "BLUE_TIER":
                      setAnimationImage(theme.image.OnePercentAnimation);
                      break;
                    case "SILVER_TIER":
                      setAnimationImage(theme.image.blueTierAnimation);
                      break;
                    case "GOLD_TIER":
                      setAnimationImage(theme.image.silverTierAnimation);
                      break;
                    case "PLATINUM_TIER":
                      setAnimationImage(theme.image.goldTierAnimation);
                      break;
                    case "ELITE_TIER":
                      setAnimationImage(theme.image.platinumTierAnimation);
                      break;
                    default:
                      setPopup(false);
                      break;
                  }
                }
                else if (is_crypto) {
                  setAnimationImage(theme.image.crypto10PercentAnimation);  // crypto reload Animation
                  // setPopup(false);
                  } else if (!is_crypto && is_redeposit) {
                    switch (userInfo.tier) {
                        case "BLUE_TIER":
                          setAnimationImage(theme.image.OnePercentAnimation); //blueTierAnimation
                          break;
                        case "SILVER_TIER":
                            setAnimationImage(theme.image.blueTierAnimation); //silverTierAnimation
                            break;
                        case "GOLD_TIER":
                            setAnimationImage(theme.image.silverTierAnimation);  //goldTierAnimation
                            break;
                        case "PLATINUM_TIER":
                            setAnimationImage(theme.image.goldTierAnimation); //platinumTierAnimation
                            break;
                        case "ELITE_TIER":
                            setAnimationImage(theme.image.platinumTierAnimation); //eliteTierAnimation
                            break;
                        default:
                            setPopup(false);
                            break;
                    }
                } else {
                    setPopup(false);
                }
            }
        
          setTransationState({
            status: status, //'Sucessfully Deposited'
            message: `${data.payment_type} ${
              status === "FAILURE" ? "FAILED" : status
            }`,
            amount: Number(data.amount).toFixed(2),
            showMsg: status,
            source:user_source,
            createdAt: created,
            transactionId: transaction_sn
          });

          // try {
          //     ReactPixel.init('739104157417039')
          //     ReactPixel.trackSingle('track', 'Purchase', { value: data.amount, currency: 'INR', status: status });
          // } catch (error) { }

          // timer.current = setTimeout(() => {
          //     setTransationState(defaultTransState);
          //     navigate(depositeUrl, { replace: true });
          // }, 10000);

          //addressablePxlPageView
          addressablePxlPageView(brandId, user_source);
          
          if (user_source && brandId) {
            if (is_first_time_deposit) {
              TriggerPxlPurchase(user_source, false, false, true, brandId, is_first_time_deposit)
            }
            else {
              TriggerPxl(user_source, false, false, true, brandId);
            }

            //Adding more pixel
            if (user_source.toLowerCase() === "channel457") {
              setNapptix({
                '31': brandId === 31,
                '47': brandId === 47
              })
            };

          }
          
         

          if (user_source && (user_source.toLowerCase() === "channel383")) {
            TriggerPxlParticular(user_source, false, false, true, false, brandId);
          }
          // for Sigment Pixel
          if (brandId === 31) {
            depositSigmentPxl(
              user_source,
              false,
              Number(data.amount).toFixed(2)
            );
          }
          //for sport radar
          if(is_first_time_deposit){
            SRTM.depositFT(brandId,userInfo.username);
            //pixel for outbrain
            if (user_source && (user_source.toLowerCase() === "channel639" || user_source.toLowerCase() === "channel175")) {
              trackOutBrainEvent('FTDSubmit');
            }

           // Track out brain pixel 
            if (brandId === 61 && user_source && (user_source.toLowerCase() === "channel1" || user_source.toLowerCase() === "channel2" || user_source.toLowerCase() === "channel3" || user_source.toLowerCase() === "channel4")) {
              trackOutBrainEvent('FTD', user_source.toLowerCase());
            }

            // Track out brain pixel 
            if (brandId === 61 && user_source && (user_source.toLowerCase() === "channel38" || user_source.toLowerCase() === "channel39" || user_source.toLowerCase() === "channel40")) {
              setTrackerads({
                ftd:true,
                rd:false
              })
            }

            addressablePxlDeposit(brandId, user_source)

          }else{
            SRTM.depositR(brandId,userInfo.username);
            // Track out brain pixel 
            if (brandId === 61 && user_source && (user_source.toLowerCase() === "channel38" || user_source.toLowerCase() === "channel39" || user_source.toLowerCase() === "channel40")) {
              setTrackerads({
                ftd:false,
                rd:true
              })
            }
             //addressablePxl
            addressablePxlReDeposit(brandId, user_source);
          }

          if(brandId === 39 && user_source){
            //Taboola Pixel Code 
            taboolaPxl(user_source,false, false, true);
         }

          //Outbrain Pixels for Fun88 – BCM
          if (brandId === 47 && user_source && user_source.toLowerCase() === "channel410") {
            setOutbrain410(true)
          }
          if (brandId === 31 && user_source && user_source.toLowerCase() === "channel1063") {
            setTaboola1063(true)
          }
          if (brandId === 31 && user_source && user_source.toLowerCase() === "channel1064") {
            setMgidpxl1064(true)
          }

          if (brandId === 31 && is_first_time_deposit && user_source.toLowerCase() === "channel1173") {
            setFinovationPxl73(true);
          }
          if (brandId === 31 && is_first_time_deposit && user_source.toLowerCase() === "channel1174") {
            setFinovationPxl74(true);
          }

          //need to call data layer
          if (brandId === 31 || brandId === 32) {
            try {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'deposit_success',
                is_ftd: is_first_time_deposit? true : false 
              });

            } catch (error) {
              console.log('Issue in data layer', error);
            }
          }

          //new fb common pixel
          fbPxlPurchase()

        })
        .catch((err) => console.log("Error", err));

      setTimeout(() => {
        setPopup(false);
      }, 8000);
    }

    //Return function
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  const closeMode = () => {
    clearTimeout(timer.current);
    setTransationState(defaultTransState);
    navigate(depositeUrl, { replace: true });
  };

  //adding one more variable for tracking event
  
  const showTracICUB = (transationState.source ==='channel1102' || transationState.source ==='channel1105' || transationState.source ==='channel1106')  && brandId === 33;
  const showMomentus = (transationState.source ==='channel10' || transationState.source ==='channel11')  && brandId === 33;

    //pixel for iw247
    const showEskimiPixel = (transationState.source === 'channel59' || transationState.source === 'channel60') && brandId === 33;
    const showRichardsPixel = (transationState.source === 'channel61' || transationState.source === 'channel62') && brandId === 33;
    const showGreedyGamesPixel = (transationState.source === 'channel63' || transationState.source === 'channel64') && brandId === 33;

    const currentChannelId = transationState.source; // This directly sets the current channel based on marketingSource

    const pixelData = [
      { showPixel: showEskimiPixel, channelId: 'channel59', page: 'deposit', events: ["BaaziDeposit"] },
      { showPixel: showEskimiPixel, channelId: 'channel60', page: 'deposit', events: ["BaaziDeposit"] },
      { showPixel: showRichardsPixel, channelId: 'channel61', page: 'deposit', events: ["BaaziDeposit"] },
      { showPixel: showRichardsPixel, channelId: 'channel62', page: 'deposit', events: ["BaaziDeposit"] },
      { showPixel: showGreedyGamesPixel, channelId: 'channel63', page: 'deposit', events: ["BaaziDeposit"] },
      { showPixel: showGreedyGamesPixel, channelId: 'channel64', page: 'deposit', events: ["BaaziDeposit"] }
    ];

  
  return (
    <MainInfoWrapper>
      <Header>
        <FirstCol>
          <UDBHeader title="DASHBOARD@DEPOSIT" link={depositeUrl} />
        </FirstCol>
      </Header>
      <>
      {/* <Player
              autoplay
              loop
              controls
              // src={`${config.imageV3Host}/static/cashsite/${theme.image.catch99BannerImg}`}
              src={`${config.imageV3NonOptHost}/static/cashsite/brand/6/image/crypto10percentreloadbonus.json`}
              style={{ height: "500px", width: "500px" }}
            ></Player> */}
        {popup === true && animationImage ? (
          <PopUpWrap>
            {/* <img src={`${config.imageV3Host}/static/cashsite/${animationImage}`} alt="1stTimePopup" /> */}
            <Player
              autoplay
              loop
              controls
              // src={`${config.imageV3Host}/static/cashsite/${theme.image.catch99BannerImg}`}
              src={`${config.imageV3NonOptHost}/static/cashsite/${animationImage}`}
              style={{ height: "500px", width: "500px" }}
            ></Player>
          </PopUpWrap>
        ) : (
          <DepositMessage
            message={transationState.message}
            status={transationState.status}
            amount={transationState.amount}
            transactionId={transationState.transactionId}
            createdAt={transationState.createdAt}
            closeHandler={closeMode}
            brandCheck={showOnlyOnFun}
          />
        )}
      </>
      {transationState.status!=='FAILURE' && showTracICUB && (<TrackingImgWrp><img src='https://tracking.icubeswire.co/aff_a?offer_id=4536&goal_id=6900' width='1' height='1' id='pixelcodeurl' alt="" /></TrackingImgWrp>)}
      {transationState.status!=='FAILURE' && showMomentus && (<TrackingImgWrp><img src='https://momentus.gotrackier.com/pixel?av=659559c38d7a8f4a0e4e5371&goal_value=deposit' width='1' height='1' alt="" /></TrackingImgWrp>)}

      {pixelData.map(({ showPixel, channelId, page, events }) =>
          showPixel && (
            <React.Fragment key={channelId}>
              {transationState.status!=='FAILURE' && <PixelsTrigger channelId={currentChannelId} page={page} event={events[0]} />}
            </React.Fragment>
          )
       )}
      {
        smartsolutionwebpixel && (<TrackingImgWrp><img alt="" src='https://smart.solution.weborama.fr/fcgi-bin/dispatch.fcgi?a.A=co&a.si=10358&a.cp=2&a.ct=d&a.cid={CLIENT_IDENTIFIER}' width='1' height='1' /></TrackingImgWrp>)
      }

      {
        trackerads.ftd && <TrackingImgWrp><div id='tracker' style={{"visibility":"hidden"}}><img src='https://debug.blockchain-ads.com/www/delivery/tracker-mobile.php?trackerid=2614' width='0' height='0' alt='' /></div></TrackingImgWrp>
      }
      {
        trackerads.rd && <TrackingImgWrp><div id='tracker' style={{"visibility":"hidden"}}><img src='https://debug.blockchain-ads.com/www/delivery/tracker-mobile.php?trackerid=2615' width='0' height='0' alt='' /></div></TrackingImgWrp>
       }

      {
        outbrain410 && <TrackingImgWrp><img src="https://napptix.g2afse.com/success.jpg?offer_id=446&afstatus=2" height="1" width="1" alt="" />  </TrackingImgWrp>
      }

      {
        taboola1063 && <TrackingImgWrp><img src="https://napptix.g2afse.com/success.jpg?offer_id=488&afstatus=2" height="1" width="1" alt="" />  </TrackingImgWrp>
      }
      {
        mgidpxl1064 && <TrackingImgWrp><img src="https://napptix.g2afse.com/success.jpg?offer_id=490&afstatus=2" height="1" width="1" alt="" />  </TrackingImgWrp>
      }

      {napptix['31'] && <TrackingImgWrp><img src="https://napptix.g2afse.com/success.jpg?offer_id=488&afstatus=2" height="1" width="1" alt="" />  </TrackingImgWrp>}
      {napptix['47'] && <TrackingImgWrp><img src="https://napptix.g2afse.com/success.jpg?offer_id=446&afstatus=2" height="1" width="1" alt="" />  </TrackingImgWrp>}

      {finovationPxl73 && <TrackingImgWrp><img src="https://pool.liftdsp.com/pixel?id=155775&t=img" height="1" width="1" alt="" />  </TrackingImgWrp>}
      {finovationPxl74 && <TrackingImgWrp><img src="https://pool.liftdsp.com/pixel?id=155775&t=img" height="1" width="1" alt="" />  </TrackingImgWrp>}


    </MainInfoWrapper>

  );
}

export default withTheme(withAppContext(DepositStatus));

//https://tracking.icubeswire.co/aff_a?offer_id=4536&goal_id=6900
//Styled Components
const PopUpWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const TrackingImgWrp = styled.div`
  position: absolute;
  top: -1100px;
  width: 1px;
  height: 1px;
`;
